// removed by extract-text-webpack-plugin
module.exports = {"wrap":"YHHofabjw5-Bl7CSOLpj7"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicSubscriptionLogin.scss
// module id = 2627
// module chunks = 0